module.exports = __webpack_public_path__ + "img/case2.5b77d68a.png";